import dayjs, { Dayjs } from "utils/dayjs"

import { Guid, IApiLink } from "@/types"
import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import i18n from "intl/i18n"

export enum RelativeHoliday {
    easter = "easter",
}

export interface IGetHolidayDto {
    id: Guid
    description: string
    date: string
    floatingHoliday?: {
        relativeHoliday: RelativeHoliday
        offset: number
    } | null
    links: IApiLink[]
}

export interface ICreateUpdateHoliday {
    description: string
    fixedHoliday?: Dayjs | null
    floatingHoliday?: {
        relativeHoliday: RelativeHoliday
        offset: number
    } | null
}

export interface ICreateUpdateHolidayDto extends Omit<ICreateUpdateHoliday, "fixedHoliday"> {
    fixedHoliday?: string | null
}

export default class Holiday {
    id: Guid
    description: string
    date: Dayjs
    floatingHoliday?: {
        relativeHoliday: RelativeHoliday
        offset: number
    }
    linkUpdate?: IApiLink

    constructor(dto: IGetHolidayDto) {
        this.id = dto.id
        this.description = dto.description
        this.date = dayjs.utc(dto.date, "YYYY-MM-DD")
        this.floatingHoliday = dto.floatingHoliday || undefined
        this.linkUpdate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.holiday && lnk.rel === ApiLinkRel.update)
    }

    static getCreateUpdateDto(data: ICreateUpdateHoliday): ICreateUpdateHolidayDto {
        return {
            description: data.description,
            fixedHoliday: data.fixedHoliday ? data.fixedHoliday.format("YYYY-MM-DD") : null,
            floatingHoliday: data.floatingHoliday,
        }
    }
}

export function getRelativeHolidayLabel(relativeHoliday: RelativeHoliday) {
    return {
        [RelativeHoliday.easter]: i18n.t("relativeHoliday.easter")
    }[relativeHoliday] || relativeHoliday
}
